module.exports = __webpack_public_path__ + "static/media/right_logo.2f1dee02.png";